<template>
  <div class="student_opus">
    <div class="btns">
      <div class="btn" :class="{'active':active==='bs'}"  @click="cutType('bs')">毕设作品</div>
      <div class="btn" :class="{'active':active==='qt'}"  @click="cutType('qt')">其他作品</div>
    </div>
    <template v-if="layerpageinfo.total > 0">
      <div class="pro_box">
        <pro_list :list="list"></pro_list>
      </div>
      <!-- 分页 -->
      <div class="page_box">
        <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
      </div>
    </template>
    <!-- 为空 -->
    <div class="no_list" v-else></div>
  </div>
</template>

<script>
import myPage from "@/components/myPage/myPage";
import pro_list from "@/components/list_item/pro_list/pro_list.vue";
export default {
  components: {
    myPage,
    pro_list
  },
  data() {
    return {
      active: "bs",
      params: {},
      layerpageinfo: {
        pageNo: 0,
        pageSize: 8,
        total: 0
      },
      searchObj: {
        // student: this.$route.query.id,
        status: "IdentityCertifieStatussuccess"
      },
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //切换作品
    cutType(type) {
      this.active = type;
      this.search();
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getList();
    },
    search() {
      this.layerpageinfo.pageNo = 0;
      this.getList();
    },
    //查询列表
    getList() {
      let params = {
        ...this.searchObj,
        ...this.layerpageinfo,
        user_id: this.$route.query.user,
        is_graduation: this.active === "bs"
      };
      this.api.getOpuses(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.list = res.obj.list;
        this.layerpageinfo.total = res.obj.totalSize;
      });
    }
  }
};
</script>

<style lang="scss">
.student_opus {
  .btns {
    margin-top: 20px;
    display: flex;
    .btn {
      width: 120px;
      height: 40px;
      color: $color-gary;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      cursor: pointer;
    }
    .btn.active{
      color: $color-default;
      border:1px solid $color-default;
      border-radius: 20px;
    }
  }
  .pro_box {
    padding: 20px 0;
  }
  .el-button--primary {
    border-radius: 20px;
  }
}
</style>
